import { render } from "./AddDiscussionProfileModeModal.vue?vue&type=template&id=8a65affe&scoped=true"
import script from "./AddDiscussionProfileModeModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddDiscussionProfileModeModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddDiscussionProfileModeModal.vue?vue&type=style&index=0&id=8a65affe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a65affe"]])

export default __exports__